import {CatalogStore} from '@stores'
import {_, action, observable, React, runInAction} from '@api'
import { CatalogInstanceChildStore } from './CatalogInstanceChildStore'

export interface CreateProductInput {
  name?: string
  category1Id?: string
  category2Id?: string
  seasonId?: string
  productCreateCount?: number
  material?: string
  hardware?: string
  color?: string
  sketch?: string
  tags?: Array<{id: string}>
  attributes?: Array<any>
}

export class MassProductCreateStore extends CatalogInstanceChildStore {
  constructor(public catalog: CatalogStore) {
    super(catalog)
  }

  @action reset = () => {
    this.anchorEl     = null
    this.productCount = 1
    this.loading      = false
    this.spec         = null
    this.viewByItem   = null
    this.override = null
  }

  @observable.ref anchorEl
  @observable lastDialogChoice: 'cancel' | 'ok';
  @observable spec
  @observable.ref specStack
  @observable.ref groupSpec
  @observable viewByItem
  @observable productCount = 1
  @observable loading      = false
  @observable productCountError
  @observable uploadingMessage: string | null = null
  @observable group

  override: {input: CreateProductInput, updateQueryVariables?: any, connectionWhere?: any } = null
  overrideQueryVariables: any = null

  @action openCreateProductsDialog = (e: React.MouseEvent<HTMLElement>, item = null, spec = 'products', overrideInput?: CreateProductInput, updateQueryVariables?: any, connectionWhere?: any) => {
    e && e.preventDefault()
    e && e.stopPropagation()
    this.anchorEl   = e.currentTarget
    this.spec       = spec
    this.viewByItem = item
    this.override = { input: overrideInput, updateQueryVariables, connectionWhere }
  }

  @action closeDialog = (e) => {
    this.anchorEl               = null
    this.productCount           = 0
    this.override               = null
  }

  getCustomAttributeValue = (attr) => {
    let attribute = attr
    attribute.definition = attribute.customAttributeDefinition.id
    delete attribute.id
    delete attribute.name
    delete attribute.colorway
    delete attribute.customAttributeDefinition
    delete attribute.__typename
  
    attribute.tag = attribute.tag && attribute.tag.id
    attribute.tagList = (attribute.tagList && !_.isArray(attribute.tagList) && _.isObject(attribute.tagList)) ? [attribute.tagList.id] : null
        
    return attribute
  }


  @action bulkCreateProduct = async (event, params: { input?: CreateProductInput, updateQueryVariables?: any, connectionWhere?: any, isImages?: boolean} = {}) => {
    // this.lastDialogChoice = 'ok'
    // this.uploadingMessage = "Creating Product(s)..."
    //
    // try {
    //   let {
    //         group, specStack, groupSpec, viewByItem: item, override,
    //         catalog:                   {es: {catalogItemFilter}, groupBy: {hierarchy, groupingByName}}, getSpecValue, getCustomAttributeValue
    //       }                                                        = this
    //   let {input, updateQueryVariables, connectionWhere, isImages} = params
    //   site.busy++
    //   input = {...input}
    //   if (override) {
    //     Object.assign(input, override.input)
    //   }
    //
    //   updateQueryVariables = updateQueryVariables || (override && override.updateQueryVariables) || (stores.catalog && {where: gql.whereProductsClause})
    //   connectionWhere      = connectionWhere || (override && override.connectionWhere) || (catalogItemFilter)
    //
    //   const productCount = this.productCount != null ? this.productCount : input ? input.productCreateCount : 0
    //
    //   if (productCount > 0 && productCount < 1000) {
    //     const {nav: {match: {params: {season, category1, category2}}}, apollo: {client}, product: {setSelectedProducts}, filter} = stores
    //     this.loading                                                                                                                          = true
    //     let massProductInput: CreateProductInput                                                                                              = {
    //       name:               "New Product",
    //       category1Id:        category1,
    //       category2Id:        category2,
    //       seasonId:           season,
    //       productCreateCount: productCount,
    //       attributes: []
    //     }
    //     _.map(hierarchy, (h, index, hierarchyArray) => {
    //       const attribute = hierarchyArray.length === index + 1 ?
    //         (groupSpec && groupSpec.length > 0) ?
    //           toJS(groupingByName.get(h).nodes.get(groupingByName.get(h).pathLookup(group, groupSpec))).definition
    //           : toJS(groupingByName.get(hierarchyArray[0]).nodes.get(group)).definition : (groupSpec && groupSpec.length > 0) ? toJS(groupingByName.get(h).nodes.get(groupSpec[index])).definition : null
    //       if(attribute && attribute["title"] !== 'Unassigned' && attribute.id && !attribute.id.endsWith('_unassigned')) {
    //         const attrToCheck = (groupSpec && groupSpec.length > 0) ? h : hierarchyArray[0]
    //         if(attrToCheck.startsWith('ca:')) {
    //             massProductInput.attributes.push(getCustomAttributeValue(attribute))
    //         } else {
    //           switch (attrToCheck) {
    //             case 'materials' :
    //               massProductInput.material = getSpecValue(attribute)
    //               break;
    //             case 'hardware' :
    //               massProductInput.hardware = getSpecValue(attribute)
    //               break;
    //             case 'colors' :
    //               massProductInput.color = getSpecValue(attribute)
    //               break;
    //             case 'styles' :
    //               massProductInput.sketch = getSpecValue(attribute)
    //               break;
    //           }
    //         }
    //       }
    //     })
    //
    //     const {filter: {state: {groups, groups: {tag}}}} = stores
    //     if (tag && tag.selected.size) {
    //       massProductInput.tags = Array.from(tag.selected.keys()).map(id => ({id}))
    //     }
    //
    //     massProductInput = {...input, ...massProductInput}
    //
    //     const {data, data: {bulkCreateProduct}} = await ProductService.bulkCreateProduct({input: massProductInput}, null, {isFormatted: true, updateQueryVariables, connectionWhere})
    //     if (!isImages) {
    //       runInAction(() => {
    //         this.reset()
    //
    //         stores.product.sidebarUpdated = true
    //         stores.product.sidebarAction = "create"
    //         // YFTS-2025 - Duplication doesn't include custom attributes and so if we're filtered we won't be selecting this product onscreen
    //         if (groups.tag.selected.size == 0 && groups.customAttributes.selected.size == 0) {
    //           setSelectedProducts(bulkCreateProduct.map(p => p.id))
    //         }
    //       })
    //     }
    //     return data
    //   }
    // } catch (err) {
    //   console.error(err)
    //   this.reset()
    // }
    // finally {
    //   site.busy--
    // }
    //
    // return null
  }

  @action bulkCreateSpecification = () => {
    // TODO: Disuss about commented logic
    // const {override} = this
    // if (override) {
    //   const {input, updateQueryVariables, connectionWhere} = override
    //   this.bulkCreateProduct(null, {input, updateQueryVariables, connectionWhere})
    //   this.override = null
    //   return
    // }

    // const {library: {selectedLibrary, activeLibraryTab}}                             = stores
    // const {nav: {match: {params: {season, category1, category2}}}, apollo: {client}} = stores
    // let specInput: any                                                               = {
    //   specCreateCount: this.productCount
    // }
    // if (!activeLibraryTab || activeLibraryTab === 'seasonal-library') {
    //   if (category2) {
    //     specInput.category2 = {id: category2}
    //   }
    //   if (category1) {
    //     specInput.category1 = {id: category1}
    //   }
    //   if (season) {
    //     specInput.season    = {id: season}
    //   }
    // }
    // this.loading = true
    // if (selectedLibrary === 'materials') {
    //   specInput.type = 'Fabric'
    // } else if (selectedLibrary === 'hardware') {
    //   specInput.type = 'Hardware'
    // }
    // let SiteLibrary: any        = client.readQuery({query: SITE_LIBRARY})
    // let SortByLibraryQueryTable: any = client.readQuery({query: SORT_BY_LIBRARY_TABLE})
    // let LibraryTablePaginationQuery  = client.readQuery({query: LIBRARY_TABLE_PAGINATION})
    // specMappings[selectedLibrary].bulkCreate.call({
    //   variables: {
    //     input: specInput
    //   }
    // }, {SiteLibrary, config: stores.config, SortByLibraryQueryTable, LibraryTablePaginationQuery}).then(() => {
    //   resetSortOrder(client)
    //   if (stores.library && stores.library.selectedLibraryView === 'table') {
    //     site.searchText = ''
    //   }
    //   runInAction(() => {
    //     this.anchorEl     = null
    //     this.productCount = 1
    //     this.loading      = false
    //   })
    // }).catch(() => {
    //   runInAction(() => {
    //     this.anchorEl     = null
    //     this.productCount = 1
    //     this.loading      = false
    //   })
    // })
  }

  @action createProductWithImages = async (files: FileList, overrideInput?: CreateProductInput, updateQueryVariables?: any, connectionWhere?: any) => {
    // this.viewByItem = null
    // this.spec = this.spec || "products"
    // this.productCount     = files.length
    // this.uploadingMessage = "Creating Product(s)..."
    // this.override = { input: overrideInput, updateQueryVariables, connectionWhere }
    //
    // let r = await this.bulkCreateProduct(null, {isImages: true})
    // if (!r) {
    //   return
    // }
    //
    // const {bulkCreateProduct: data} = r
    // this.loading                            = true
    // if (files.length) {
    //   this.uploadingMessage = 'Uploading image(s)...'
    //   const {}              = this
    //   try {
    //     const response = await Promise.all(utils.resolveImages(files, 0, false))
    //     const results  = await utils.uploadImages(response)
    //     let uploadResults = await Promise.all(_.map(results, (result: any, index) => this.uploadColorwayImages(data[index].colorway.id, [result.id])));
    //     uploadResults = uploadResults.map(({data: {updateColorwayImages: colorway}}) => colorway)
    //     data.colorway = _.last(uploadResults)
    //     return data
    //   } finally {
    //     this.reset()
    //
    //     const {product, catalog: {groupBy: {queryManager}}} = stores
    //     product.setSelectedProducts(data.map(p => p.id))
    //
    //     // If done inline the virtualized product card row doesn't update
    //     setTimeout(() => queryManager.refetchAll(), 50)
    //   }
    // }
  }

  @action uploadColorwayImages = (id: string, images: Array<{ data: { updateColorwayImages }}>) => {
    // return gql.products.updateColorwayImages({
    //   variables: {
    //     input: {images},
    //     where: {id: id}
    //   }
    // })
  }

  @action onChangeProductCount = (e) => {
    let count = parseInt(e.target.value)
    if (!count) {
      count = 0
    }
    if (count < 1000 && count > -1) {
      this.productCount = count
    }
  }

  @action incrementProductCount = () => {
    this.productCount = Math.min(this.productCount + 1, 1000)
  }

  @action decrementProductCount = () => {
    this.productCount = Math.max(this.productCount - 1, 0)
  }

  @action onCloseMassCreation = (e) => {
    this.lastDialogChoice = 'cancel'
    this.anchorEl     = null
    this.productCount = 1
  }
  @action setProductCount = (event) => {
    if (typeof event.target.value === "number") {
      this.productCount = event.target.value;
    } else {
      this.productCount = Number(event.target.value);
    }
  }

  @action handleSlider = (event, value) => {
    this.productCount = value;
  }

  get productInput() {
    let tags                                                = []
    const {state: {groups: {tag}}} = this.stores.filter

    if (tag && tag.selected.size) {
      tags = Array.from(tag.selected.keys()).map(id => ({id}))
    }

    return {
      //...gql.librariesQueryVariables,
      tags:        tags,
      material:    null,
      hardware:    null,
      sketch:      null,
      color:       null,
      attributes:  null
    }
  }

  createMassProduct = async (images = [], id = null, typeName = null) => {
    runInAction(() => {
      this.loading          = true
      this.uploadingMessage = 'Creating Product(s)...'
    })
    const {productCount, viewByItem: item, spec}                               = this
    const {filter: {state: {groups: {tag}}}, nav: {params: {season, category2, category1}}} = this.stores

    let tags = []
    if (tag && tag.selected.size) {
      tags = Array.from(tag.selected.keys()).map(id => ({id}))
    }

    let massProductInput: any = {
      name:               "New Product",
      productCreateCount: images.length ? images.length : productCount,
     // ...gql.librariesQueryVariables
    }
    if (tags.length > 0) {
      massProductInput.tags = tags
    }

    if (item !== 'unassigned') {
      switch (typeName) {
        case 'Material':
          if (spec === 'materials') {
            massProductInput.material = id
          } else {
            massProductInput.hardware = id
          }
          break
        case 'Color':
          massProductInput.color = id
          break
        case 'Sketch':
          massProductInput.sketch = id
          break
      }
    }

    // try {
    //   const product = await ProductService.bulkCreateProduct({
    //     input: massProductInput
    //   }, null, {data: this.productInput, isFormatted: true})
    //
    //   const data = product.data.bulkCreateProduct
    //   if (images.length) {
    //     this.uploadingMessage = 'Uploading image(s)...'
    //     const response        = await utils.resolveImages(images, 0, false)
    //     const results         = await utils.uploadImages(response)
    //     const uploadResults   = await Promise.all(results.map((result: any, index) => this.uploadColorwayImages(data[index].colorway.id, [result.id])));
    //
    //     runInAction(() => {
    //       this.loading          = false
    //       this.uploadingMessage = null
    //     })
    //   }
    // } catch (err) {
    //   runInAction(() => {
    //     this.loading          = true
    //     this.uploadingMessage = null
    //   })
    // }
  }
}




// WEBPACK FOOTER //
// ./src/stores/catalog/MassProductCreateStore.ts